/**
 * Comparator for Market Share scope-type filter names ("All Publishers" / "All Genres" /
 * "All Subgenres" dropdown entries). Sorts case-insensitively so that e.g. 'amanotes'
 * interleaves with 'Amanotes' instead of all uppercase-starting names coming first. (GR-2989)
 */
export const compareMarketShareScopeTypeFilterNames = (a: { name: string }, b: { name: string }): number =>
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
